document.addEventListener('alpine:init', () => {
    Alpine.data('singleFaq', () => ({
        _open: false,
        init() {
            const id = this.getAnchorId();
            if (id && window.location.hash === `#${id}`) {
                this._open = true;
            }
        },
        isOpen() {
            return this._open;
        },
        toggle() {
          if (!this.isOpen()) {
              this.open();
          } else {
              this.close();
          }
        },
        open() {
            this._open = true;
            this.setAnchor();
        },
        openInitial() {
            this._open = true;
        },
        close() {
            this._open = false;
            this.clearAnchor();
        },
        getAnchorId() {
            const id = this.$root?.id || this.$el?.id || '';
            return id.trim();
        },
        setAnchor() {
            const id = this.getAnchorId();
            if (!id) {
                return;
            }
            const targetHash = `#${id}`;
            if (window.location.hash === targetHash) {
                return;
            }
            const url = `${window.location.pathname}${window.location.search}${targetHash}`;
            window.history.replaceState(null, '', url);
        },
        clearAnchor() {
            const id = this.getAnchorId();
            if (!id) {
                return;
            }
            if (window.location.hash !== `#${id}`) {
                return;
            }
            const url = `${window.location.pathname}${window.location.search}`;
            window.history.replaceState(null, '', url);
        }
    }));
});
